export type FilterChipKey = 'search' | 'product' | 'dates';

export interface ReportFilterChip {
  key: FilterChipKey;
  label: string;
  text: string;
}

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** `YYYY-MM-DD` as `dd Mon yyyy`, built from the parts so a time zone can never shift the day. */
function formatYmd(value: string): string {
  const [year, month, day] = value.split('-');
  return `${day} ${MONTHS[Number(month) - 1]} ${year}`;
}

export function periodLabel(dateFrom?: string, dateTo?: string): string {
  return dateFrom && dateTo ? `${formatYmd(dateFrom)} – ${formatYmd(dateTo)}` : 'All time';
}

/** One chip per active filter. A date range counts only when both ends are set, as the page itself requires. */
export function buildFilterChips(f: {
  search: string;
  productType: string;
  dateFrom?: string;
  dateTo?: string;
}): ReportFilterChip[] {
  const chips: ReportFilterChip[] = [];
  const search = f.search.trim();
  if (search) chips.push({ key: 'search', label: 'Search', text: search });
  if (f.productType) chips.push({ key: 'product', label: 'Product', text: f.productType });
  if (f.dateFrom && f.dateTo) chips.push({ key: 'dates', label: 'Dates', text: periodLabel(f.dateFrom, f.dateTo) });
  return chips;
}
